export default {
  ativo(state) {
    return state.ativo;
  },
  produtos(state) {
    return state.produtos;
  },
  itens(state) {
    return state.itens;
  },
  parcelas(state) {
    return state.parcelas;
  },
  form(state) {
    return state.form;
  },
  selects(state) {
    return state.selects;
  }
};
